import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// 小圆球位置状态
export interface AssistiveTouchPosition {
  x: number;
  y: number;
}

// 小圆球是否显示 - 使用 localStorage 持久化，默认关闭
export const assistiveTouchVisibleAtom = atomWithStorage<boolean>('assistiveTouchVisible', false);

// 小圆球位置 - 使用 localStorage 持久化
export const assistiveTouchPositionAtom = atomWithStorage<AssistiveTouchPosition>('assistiveTouchPosition', {
  x: 20, // 默认位置 - 距离右侧20px
  y: 300, // 默认位置 - 距离顶部300px
});

// 小圆球是否处于拖拽状态
export const assistiveTouchDraggingAtom = atom<boolean>(false);

// 小圆球临时隐藏状态 (30秒后自动显示)
export const assistiveTouchTempHiddenAtom = atom<boolean>(false);

// 小圆球菜单是否打开
export const assistiveTouchMenuOpenAtom = atom<boolean>(false);

// 当前激活的版本
export const activeVersionAtom = atomWithStorage<string>('activeVersion', 'v3');

// Atom to control visibility of Shake UI via AssistiveTouch
export const showShakeUIAccessoryAtom = atom<boolean>(false);

// Atom to control visibility of Hotjar Survey via AssistiveTouch
export const showHotjarSurveyAccessoryAtom = atom<boolean>(false);

// Shake SDK 是否已初始化
// export const shakeInitializedAtom = atom<boolean>(false);

// Hotjar 是否已初始化
// export const hotjarInitializedAtom = atom<boolean>(false);
